import { observer } from 'mobx-react-lite';
import { scrollTo } from '../UI';

export default observer(() => {
  const handleClick = () => scrollTo('scroll-layout', 0, 200);

  return <div className="scroll-top" onTouchStart={handleClick} />;
});
